"use client"
import { useState } from "react"
import { sqftToPanels } from "@/lib/seo/calculators"
import { plural } from "@/lib/seo/format"
import { inputClass } from "@/components/site/page-kit"
import { T } from "@/components/seo/type"

const num = (s: string) => (s.trim() === "" ? NaN : Number(s))

export function SqftToPanelsCalculator() {
  const [width, setWidth] = useState("10")
  const [height, setHeight] = useState("9")
  const [panelWidth, setPanelWidth] = useState("6")
  const [panelLength, setPanelLength] = useState("8")
  const out = sqftToPanels({ wallWidthFt: num(width), wallHeightFt: num(height), panelWidthIn: num(panelWidth), panelLengthFt: num(panelLength) })
  return (
    <form className="grid gap-4 md:grid-cols-[1fr_1fr_1fr_1fr_auto] md:items-end" onSubmit={(e) => e.preventDefault()} aria-describedby="sqft-to-panels-result">
      <label className="flex flex-col gap-1.5"><span className={T.label}>Wall width (ft)</span><input className={inputClass} inputMode="decimal" value={width} onChange={(e) => setWidth(e.target.value)} /></label>
      <label className="flex flex-col gap-1.5"><span className={T.label}>Wall height (ft)</span><input className={inputClass} inputMode="decimal" value={height} onChange={(e) => setHeight(e.target.value)} /></label>
      <label className="flex flex-col gap-1.5"><span className={T.label}>Panel width (in)</span><input className={inputClass} inputMode="decimal" value={panelWidth} onChange={(e) => setPanelWidth(e.target.value)} /></label>
      <label className="flex flex-col gap-1.5"><span className={T.label}>Panel length (ft)</span><input className={inputClass} inputMode="decimal" value={panelLength} onChange={(e) => setPanelLength(e.target.value)} /></label>
      <p id="sqft-to-panels-result" aria-live="polite" className="rounded-xl bg-hv-paper p-4 text-hv-ink md:min-w-[220px]">
        {out ? <><span className={T.figure}>{plural(out.panels, "panel")}</span><br /><span className="mt-1.5 inline-block text-sm leading-relaxed text-hv-soft">{out.columns} across for {out.areaSqft} sq ft, plus 10% wastage, with offcuts joined. {plural(out.panelsUncut, "panel")} if every run must be one uncut panel.</span></> : <span className="text-sm text-hv-soft">Every measurement must be above 0.</span>}
      </p>
    </form>
  )
}
